import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { usePageEventsTracker } from '@infl-ts/util-page-events-tracker';
import { Box, Button, styled } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { DangerouslySetInnerHTML } from '../../froala-dangerously-set-inner-html';
import { modalPages, onboardingCategories } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledWelcomeMessage = styled(DangerouslySetInnerHTML)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .welcome-hub-name,\n  .program-benefit-title {\n    color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.primary.main;
});
export default function WelcomeMessage(_ref2) {
  var message = _ref2.message,
      onContinue = _ref2.onContinue;

  var _usePageEventsTracker = usePageEventsTracker(),
      startActivity = _usePageEventsTracker.startActivity;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  useEffect(function () {
    return startActivity(onboardingCategories.standard, modalPages.welcome);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledWelcomeMessage, {
      sx: {
        maxWidth: '900px'
      },
      body: message,
      "data-element": "StyledWelcomeMessage",
      "data-component": "WelcomeMessage",
      "data-source-file": "welcome-message.tsx"
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        pb: 4
      },
      "data-element": "Box",
      "data-source-file": "welcome-message.tsx",
      children: /*#__PURE__*/_jsx(Button, {
        variant: "contained",
        onClick: onContinue,
        "data-element": "Button",
        "data-source-file": "welcome-message.tsx",
        children: t('Continue')
      })
    })]
  });
}